<template>
  <v-text-field
    :loading="searchingLoader"
    :suffix="getSuffixPlaceholder"
    :value="searchValue"
    class="ma-0 pa-0"
    color="white"
    height="40"
    placeholder="Search your project..."
    dense
    hide-details
    rounded
    @input="search">
    <template #prepend-inner>
      <v-icon
        color="white"
        size="20">
        mdi-magnify
      </v-icon>
    </template>

    <template
      v-if="searchValue"
      #append>
      <v-icon
        v-for="arrow in arrows"
        :key="arrow.icon"
        :disabled="searchingLoader || disabledSearchingActions"
        class="v-icon v-icon__control-arrows black white--text"
        @click="arrowControl(arrow.method)">
        {{ arrow.icon }}
      </v-icon>
      <v-icon
        v-if="searchValue"
        class="ml-2 black white--text"
        @click="searchValue = null">
        mdi-close
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import { debounce } from 'lodash';
import { DEBOUNCE_TIME_FOR_SEARCHING } from '@/constants';
const DEBOUNCE_TIME_FOR_ARROW_CONTROL = 150;
export default {
  name: 'ProjectDetailsSearchCells',
  data() {
    return {
      arrows: {
        down: {
          icon: 'mdi-chevron-down',
          method: 'arrowUp',
        },
        up: {
          icon: 'mdi-chevron-up',
          method: 'arrowDown',
        },
      },
    };
  },
  computed: {
    ...mapState('SearchProjectCells', ['searchingLoader', 'currentIndexResultItem', 'searchString']),
    ...mapGetters('SearchProjectCells', ['searchingResultLength', 'getCurrentResultItem']),
    searchValue: {
      get() {
        return this.searchString;
      },
      set(val) {
        this.setSearchString(val);
      },
    },
    currentSearchingElementId() {
      const { field, rowId, isListing } = this.getCurrentResultItem || {
      };
      if (!rowId || (!field && !isListing)) return '';
      return isListing ? rowId : `${rowId}--${field}`;
    },
    currentIndex: {
      get() {
        return this.currentIndexResultItem;
      },
      set(val) {
        const { searchingResultLength: leng } = this;
        let value = val;
        if (val === 0) {
          value = leng;
        } else if (val > leng) {
          value = 1;
        }
        this.setCurrentIndexResultItem(value);
      },
    },
    disabledSearchingActions() {
      const { searchValue, searchingResultLength } = this;
      return !(searchValue && searchingResultLength);
    },
    getSuffixPlaceholder() {
      const { disabledSearchingActions: disabled, currentIndex: curr, searchingResultLength: leng, searchValue } = this;
      if (!searchValue) return '';
      if (disabled) return '0 of 0';
      return `${curr} of ${leng}`;
    },
  },
  watch: {
    searchValue(val) {
      if (val) {
        return;
      }
      this.resetSearching();
    },
    currentIndex: {
      async handler(val) {
        await this.$nextTick();
        const { currentSearchingElementId: id } = this;
        if (!val || !id) {
          return;
        }
        const el = document.getElementById(id);
        if (!el) {
          return;
        }
        el.scrollIntoView({
          block: 'center',
          inline: 'center',
        });
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.searchValue = null;
    this.resetSearching();
  },
  methods: {
    ...mapActions('SearchProjectCells', ['searchProjectCells', 'resetSearching']),
    ...mapMutations('SearchProjectCells', ['setCurrentIndexResultItem', 'setSearchString']),
    search(e) {
      this.resetSearching();
      this.debouncedSearch(e);
    },
    debouncedSearch: debounce(function(e) {
      this.searchHandle(e);
    }, DEBOUNCE_TIME_FOR_SEARCHING),
    debouncedArrowControl: debounce(function(method) {
      this[method]();
    }, DEBOUNCE_TIME_FOR_ARROW_CONTROL),
    arrowControl(method) {
      if (!method) return;
      this.debouncedArrowControl(method);
    },
    arrowDown() {
      this.currentIndex -= 1;
    },
    arrowUp() {
      this.currentIndex += 1;
    },
    searchHandle(val) {
      this.searchValue = val;
      if (!val) {
        return;
      }
      this.searchProjectCells({
        projectId: this.$route.params.id,
        query: val,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field {
  max-width: 500px;

  ::v-deep &__suffix {
    color: var(--v-white-base);
  }

  ::v-deep {
    .v-input__slot {
      gap: 8px;
      padding: 0 18px 0 12px;
    }

    .v-input__prepend-inner {
      align-self: center;
      padding: 0;
    }

    .v-input__append-inner {
      align-self: stretch;
      align-items: center;
    }

    .v-input__control {
      background-color: var(--v-black-base);
    }

    input {
      color: var(--v-white-base);

      &::placeholder {
        color: var(--v-white-base);
      }
    }
  }
}
</style>
